import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-015733cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-ai-center" }
const _hoisted_2 = {
  key: 0,
  class: "p-pl-2",
  style: {"padding-right":"1em"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user large-icon" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "user-info-fields" }
const _hoisted_6 = {
  key: 2,
  class: "p-d-flex p-flex-column p-jc-end p-ai-center inputfield"
}
const _hoisted_7 = {
  key: 3,
  class: "p-col-5 p-sm-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-ml-6 p-mt-2" }, " * Campi obbligatori ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GvInputText = _resolveComponent("GvInputText")!
  const _component_GVPassword = _resolveComponent("GVPassword")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_openBlock(), _createBlock(_component_GvSpinner, { "is-loading": _ctx.isLoading }, {
    default: _withCtx(() => [
      _createVNode(_component_Card, { style: {"width":"100%"} }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.props.showAvatar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields,
                class: "inputfield",
                "field-name": "Nome *",
                id: "firstName",
                errors: _ctx.v$.firstName.$silentErrors,
                "is-dirty": _ctx.v$.firstName.$dirty,
                modelValue: _ctx.v$.firstName.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.firstName.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields,
                class: "inputfield",
                "field-name": "Cognome *",
                id: "lastName",
                errors: _ctx.v$.lastName.$silentErrors,
                "is-dirty": _ctx.v$.lastName.$dirty,
                modelValue: _ctx.v$.lastName.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.lastName.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields || _ctx.props.fetchData,
                class: "inputfield",
                "field-name": "Indirizzo email *",
                id: "email",
                errors: _ctx.v$.email.$silentErrors,
                "is-dirty": _ctx.v$.email.$dirty,
                modelValue: _ctx.v$.email.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.email.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              (!_ctx.props.fetchData)
                ? (_openBlock(), _createBlock(_component_GVPassword, {
                    key: 0,
                    disabled: _ctx.props.disableFields,
                    class: "inputfield",
                    "field-name": "Password *",
                    id: "password",
                    type: "password",
                    errors: _ctx.v$.password.$silentErrors,
                    "is-dirty": _ctx.v$.password.$dirty,
                    modelValue: _ctx.v$.password.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.password.$model) = $event))
                  }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]))
                : _createCommentVNode("", true),
              (!_ctx.props.fetchData)
                ? (_openBlock(), _createBlock(_component_GVPassword, {
                    key: 1,
                    disabled: _ctx.props.disableFields,
                    class: "inputfield",
                    "field-name": "Conferma password *",
                    id: "confirmPassword",
                    type: "password",
                    errors: _ctx.v$.confirmPassword.$silentErrors,
                    "is-dirty": _ctx.v$.confirmPassword.$dirty,
                    modelValue: _ctx.v$.confirmPassword.$model,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.confirmPassword.$model) = $event))
                  }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.props.fetchData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_Button, {
                      class: "gv-button",
                      style: {"width":"fit-content"},
                      onClick: _ctx.resetPassword,
                      label: "Cambia password"
                    }, null, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_7))
            ])
          ])
        ]),
        _: 1
      }),
      _hoisted_8
    ]),
    _: 1
  }, 8, ["is-loading"]))
}